/**
 * OpenAPI definition
 *
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * Referral Agent creation request
 */
export interface ReferralAgentCreationRequest {
  name: string;
  /**
   * Commission rate must be >= 0 and <= 1
   */
  commissionRate: number;
}
